module.exports = __webpack_public_path__ + "media/images/icons/hammer-fb3b45bb9a9f9cc52cf4b38b4aa1a6e4.png";